import {
    AfterContentInit,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren,
    ViewEncapsulation,
} from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { LabCase } from "../case";
import { TranslateService } from "@ngx-translate/core";
import { CasesService } from "../cases.service";
import { MatTableDataSource } from "@angular/material/table";
import { el } from "date-fns/locale";
import { ApiService } from "app/main/module/common/service/api.service";
import { MatDialog } from "@angular/material/dialog";
import { AddCaseDialogComponent } from "../add-case/add-case-dialog.component";
import { element } from "protractor";
import { Globals } from "app/main/module/common/global";
import { NavigationEnd, Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { EditCaseDialogComponent } from "../edit-case/edit-case-dialog.component";
import { Subscription } from "rxjs";
import { get } from "lodash";
import * as moment from "moment";
import { ReminderRefreshService } from "../reminderRefresh.service";
import { StorageService } from "app/main/module/common/service/storage.service";

@Component({
    selector: "app-case-list",
    templateUrl: "./case-list.component.html",
    styleUrls: ["./case-list.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class CaseListComponent implements OnInit, AfterViewInit, OnDestroy {
    titleMatIcon = this.getTitleMatIcon();
    displayedColumns = [];
    columns: any[] = [];
    page: number;
    perPage: number;
    allCases: LabCase[] = [];
    allCaseData: LabCase[] = [];
    dataSource = new MatTableDataSource<any>(this.allCaseData);
    dataSourceFilters = new MatTableDataSource(this.allCaseData);
    dataSourceWithPageSize = new MatTableDataSource(this.allCaseData);
    caseStatus = [
        { value: "assigned", label: "Assigned" },
        { value: "received", label: "Received" },
        { value: "completed", label: "Completed" },
    ];
    isInitComplete: Boolean = false;
    searchText: string = "";
    isLoading: Boolean = false;
    selectedStatus: string = "";
    next: number = 1;
    prev: number = 0;
    isNextPressed: boolean = false;
    count: number = 0;
    totalPage: boolean = false;
    detailPagePath = "/cases/casedetails";
    currentPagePath = "/cases/cases-list";
    routerSubscription: Subscription;
    isSearch: boolean = false;
    status: string = "";
    translatedStatusMessages: any[] = [];
    columnWidths: { [key: string]: number } = {};
    hasMoreData: boolean = true;
    PAGE_SIZE: number = 10;
    private observer: MutationObserver | null = null;
    overflowFlags: boolean[] = [];
    @ViewChildren("cellContent") cellContents!: QueryList<ElementRef>;
    searchDisabled: boolean = false;

    constructor(
        public translate: TranslateService,
        public casesService: CasesService,
        public apiService: ApiService,
        public dialog: MatDialog,
        public global: Globals,
        private router: Router,
        public snackbar: MatSnackBar,
        public reminderRefreshService: ReminderRefreshService,
        private el: ElementRef,
        private cdr: ChangeDetectorRef,
        public storageServise: StorageService,
    ) {
        this.selectedStatus =
            localStorage.getItem("selectedCaseStatus") || "all";
    }

    ngOnInit(): void {
        this.isInitComplete = true;

        this.translate
            .get(this.caseStatus.map((status) => `LabCases.${status.value}`))
            .subscribe((res) => {
                this.translatedStatusMessages = this.caseStatus.map(
                    (status) => ({
                        label:
                            res[
                                `LabCases.${status.label.toLocaleLowerCase()}`
                            ] || status.label.toLocaleLowerCase(),
                        value: status.value,
                    }),
                );
            });

        const keys = [
            "Common.Sr",
            "LabCases.Title",
            // "LabCases.Description",
            "LabCases.PatientName",
            "LabCases.LabName",
            "LabCases.RequestedOn",
            "LabCases.ProbableReceiveDate",
            "LabCases.ReceivedOn",
            "LabCases.PaitentBookedOn",
            "LabCases.Reminder",
            "LabCases.Status",
            "LabCases.Created",
            // "LabCases.Updated",
            "Common.edit",
            "Common.Details",
        ];
        this.translate.onLangChange.subscribe(() => {
            this.translate.get(keys).subscribe((translations) => {
                this.columns = this.getColumn(translations);
                this.displayedColumns = this.columns.map((c) => c.columnDef);
            });
        });

        this.translate.get(keys).subscribe((translations) => {
            this.columns = this.getColumn(translations);
            this.displayedColumns = this.columns.map((c) => c.columnDef);
        });

        this.dataSource.data = [];
        this.allCaseData = [];
        this.isLoading = true;
        this.prev = 0;
        this.next = 1;
        this.page = 0;
        this.count = 1;
        this.perPage = 10;
        this.selectedStatus =
            localStorage.getItem("selectedCaseStatus") || "all";

        this.getAllCases(1);
        this.routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (
                    !event.url.includes(this.detailPagePath) &&
                    !event.url.includes(this.currentPagePath)
                ) {
                    localStorage.removeItem("selectedCaseStatus");
                }
            }
        });

        this.columns.forEach((col) => {
            if (!this.columnWidths[col.columnDef]) {
                const baseWidth = this.getTextWidth(col.header) + 40;
                this.columnWidths[col.columnDef] =
                    baseWidth < 100 ? 100 : baseWidth;
            }
        });

        this.reminderRefreshService.refresh$.subscribe(() => {
            this.refreshTable();
        });
    }

    getTitleMatIcon(): string {
        return "assignment";
    }

    getAllCases(page) {
        this.isInitComplete = true;
        this.totalPage = false;
        this.perPage = 10;
        this.searchText = "";
        this.searchDisabled = false;
        // console.log(this.selectedStatus);

        let status = this.selectedStatus == "all" ? "" : this.selectedStatus;
        this.casesService.getCases(page, this.perPage, status).subscribe(
            (response: any) => {
                if (response.message == "No data Found") {
                    this.totalPage = true;
                    this.isInitComplete = false;
                }
                if (response && response.data.length > 0) {
                    this.allCases = response.data;
                    this.allCaseData.push(...this.allCases);
                    this.dataSource.data = this.allCaseData;
                    this.isInitComplete = false;
                    this.hasMoreData = this.allCases.length === this.PAGE_SIZE;
                    if (!this.hasMoreData && this.isNextPressed) {
                        this.openSnackBar(
                            this.translateSentence(
                                "Common.noFurtherDataAvailable",
                            ),
                            this.translateSentence("Common.ok"),
                        );
                    }
                } else {
                    this.allCases = [];
                    this.totalPage = true;
                    this.isInitComplete = false;
                    // console.log("Inside else");

                    this.openSnackBar(
                        this.translateSentence("Common.noDataFound"),
                        this.translateSentence("Common.ok"),
                    );
                }
            },
            (error) => {
                console.error("Error fetching cases:", error);
                this.totalPage = true;
                this.isInitComplete = false;
                let errorMessage = error.error.message;
                this.openSnackBar(
                    errorMessage,
                    this.translateSentence("Common.ok"),
                );
            },
        );
    }

    getColumn(translations: { [key: string]: string }): any[] {
        return [
            {
                columnDef: "SrCasessette",
                header: translations["Common.Sr"],
                cell: (element: LabCase, index: number) =>
                    `${this.page * 10 + index + 1}`,
            },
            {
                columnDef: "Title",
                header: translations["LabCases.Title"],
                cell: (element: LabCase, index: number) => element.title || "",
            },
            // {
            //     columnDef: "Description",
            //     header: translations["LabCases.Description"],
            //     cell: (element: LabCase, index: number) =>
            //         element.description || "",
            // },
            {
                columnDef: "PatientName",
                header: translations["LabCases.PatientName"],
                cell: (element: LabCase, index: number) =>
                    element.patient_name || "",
            },
            {
                columnDef: "LabName",
                header: translations["LabCases.LabName"],
                cell: (element: LabCase, index: number) => element.lab_id || "",
            },
            {
                columnDef: "RequestedOn",
                header: translations["LabCases.RequestedOn"],
                cell: (element: LabCase, index: number) =>
                    element.requested_on
                        ? this.changeDate(element.requested_on)
                        : "-",
            },
            {
                columnDef: "ProbableReceiveDate",
                header: translations["LabCases.ProbableReceiveDate"],
                cell: (element: LabCase, index: number) =>
                    element.probable_received_date
                        ? this.changeDate(element.probable_received_date)
                        : "-",
            },
            {
                columnDef: "ReceivedOn",
                header: translations["LabCases.ReceivedOn"],
                cell: (element: LabCase, index: number) =>
                    element.received_on
                        ? this.changeDate(element.received_on)
                        : "-",
            },
            {
                columnDef: "PatientBookedOn",
                header: translations["LabCases.PaitentBookedOn"],
                cell: (element: LabCase, index: number) =>
                    element.patient_booked_on
                        ? this.changeDate(element.patient_booked_on)
                        : "-",
            },
            {
                columnDef: "Status",
                header: translations["LabCases.Status"],
                cell: (element: LabCase, index: number) => {
                    const key = `LabCases.${element.status}`;
                    return this.translateSentence(key);
                },
                textColor: (element: LabCase, index: number) => {
                    return this.getColourByStatus(element.status);
                },
            },
            // {
            //     columnDef: "Created",
            //     header: translations["LabCases.Created"],
            //     cell: (element: LabCase, index: number) =>
            //         element.created ? this.changeDate(element.created) : "-",
            // },
            // {
            //     columnDef: "Updated",
            //     header: translations["LabCases.Updated"],
            //     cell: (element: LabCase, index: number) =>
            //         element.updated ? this.changeDate(element.updated) : "-",
            // },
            {
                columnDef: "Edit",
                header: translations["Common.edit"],
                cell: (element: LabCase, index: number) => {
                    element.id;
                },
            },
            {
                columnDef: "details",
                header: translations["Common.Details"],
                cell: (element: LabCase, index: number) => {
                    element.id;
                },
            },
        ];
    }

    changeDate(date): any {
        // // // console.log(e);
        var timestamp = parseInt(date);
        return (date = this.getDateStringMomentByTz(timestamp));
    }

    getDateStringMomentByTz(timestamp: any): string {
        if (timestamp) {
            if (timestamp < 0) timestamp = timestamp * -1;
            const localTimeZone = moment(timestamp).tz(
                this.storageServise.getCookie("defaultTz"),
            );
            return localTimeZone.format("DD-MM-YYYY");
        }
        return "";
    }

    openAddCaseDialog(): void {
        const dialogRef = this.dialog.open(AddCaseDialogComponent, {
            disableClose: true,
            width: "525px",
            data: {},
        });

        dialogRef.beforeClosed().subscribe((bfrC) => {});
        dialogRef.afterClosed().subscribe((result) => {});
    }

    openEditCaseDialog(row): void {
        const dialogRef = this.dialog.open(EditCaseDialogComponent, {
            disableClose: true,
            width: "525px",
            data: { id: row.id, status: row.status },
        });

        dialogRef.beforeClosed().subscribe((bfrC) => {});
        dialogRef.afterClosed().subscribe((result) => {});
    }

    viewCaseDetails(caseId) {
        this.router.navigate(["/cases/casedetails"], {
            queryParams: { case_id: caseId },
        });
    }

    onClickSearch(searchText) {
        this.isInitComplete = true;
        this.perPage = 10;
        this.selectedStatus = "all";
        localStorage.setItem("selectedCaseStatus", "all");
        this.searchText = searchText.trim();
        this.isLoading = true;
        this.isSearch = true;
        this.searchDisabled = true;
        // console.log("searchText: ", searchText);

        this.casesService
            .searchCase(this.searchText, this.next, this.perPage)
            .subscribe(
                (a) => {
                    Object.entries(a).find(([key, value]) => {
                        if (key == "message" && value == "No data Found") {
                            this.totalPage = true;
                            this.isInitComplete = false;
                            this.searchDisabled = false;
                        }
                        if (key == "data") {
                            this.isInitComplete = false;
                            this.allCases = Array.isArray(value)
                                ? (value as LabCase[])
                                : [];
                            this.hasMoreData =
                                this.allCases.length === this.PAGE_SIZE;
                            if (!this.hasMoreData && this.isNextPressed) {
                                this.openSnackBar(
                                    this.translateSentence(
                                        "Common.noFurtherDataAvailable",
                                    ),
                                    this.translateSentence("Common.ok"),
                                );
                            }
                            this.searchDisabled = false;
                            // console.log("value:", value);
                        } else if (key == "status" && value == "failed") {
                            this.isLoading = false;
                            this.isInitComplete = false;
                            this.searchDisabled = false;
                            this.openSnackBar(
                                this.translateSentence("Common.noDataFound"),
                                this.translateSentence("Common.ok"),
                            );
                        }
                    });
                    this.allCaseData.push(...this.allCases);
                    this.dataSource.data = this.allCaseData;
                },
                (err) => {
                    this.isInitComplete = false;
                    this.searchDisabled = false;
                    this.openSnackBar(err.error.message, "Ok");
                },
            );
    }

    handleSearchCase(searchText: string) {
        if (!searchText || !searchText.trim()) {
            this.openSnackBar(
                this.translateSentence("Common.noSearchValueAvailable"),
                this.translateSentence("Common.ok"),
            );
            return;
        }
        this.next = 1;
        this.prev = 0;
        this.totalPage = false;
        this.isNextPressed = false;
        this.dataSource.data = [];
        this.allCases = [];
        this.allCaseData = [];
        this.onClickSearch(searchText);
    }

    openSnackBar(message: string, action: string): void {
        // this.isLoading = true;
        // this.hasFirstDataShown = true;
        this.snackbar.open(message, action, {
            duration: 1000,
        });
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }

    refreshSearch(event) {
        if (event.code === "Backspace" && this.searchText.length === 1) {
            this.searchText = "";
            this.dataSource.data = [];
            this.allCases = [];
            this.allCaseData = [];
            this.onClickSearch(this.searchText);
        }
    }

    clearInputSearch() {
        this.searchText = "";
        localStorage.setItem("selectedCaseStatus", "all");
        this.ngOnInit();
        this.searchDisabled = false;
        this.isSearch = false;
    }

    filterCaseByStatus() {
        this.dataSource.data = [];
        this.allCases = [];
        this.allCaseData = [];
        this.next = 1;
        this.page = 0;
        this.prev = 0;
        this.isSearch = false;
        localStorage.setItem("selectedCaseStatus", this.selectedStatus);
        this.getAllCases(this.next);
    }

    onNextPress() {
        this.isLoading = true;
        this.isNextPressed = true;
        this.count = this.count + 1;
        this.next = this.prev + 1;
        this.prev = this.next - 1;
        this.next++;
        this.prev++;
        if (this.isSearch) {
            this.onClickSearch(this.searchText);
        } else {
            this.getAllCases(this.next);
        }
    }

    getRowBackgroundColor(element): string {
        return "#FFFFFF";
    }

    getRowFontStyle(element) {
        if (element.status == "completed") {
            return "italic";
        } else return "bold";
    }

    getFontColor(element) {
        if (element.status == "completed") {
            return "#808080";
        } else return "#000000";
    }

    toUpperCaseString(str: string): string {
        if (!str) return "";
        return str.trim().charAt(0).toUpperCase() + str.trim().slice(1);
    }

    getColourByStatus(status: string): string {
        switch (status.toLowerCase()) {
            case "assigned":
                return "#FF8C00";
            case "received":
                return "#008000";
            default:
                return "#A9A9A9";
        }
    }

    ngAfterViewInit(): void {
        const table: HTMLElement | null =
            this.el.nativeElement.querySelector("mat-table");
        if (!table) return;

        this.observer = new MutationObserver((mutations) => {
            if (!this.isNextPressed) return;

            const rows = table.querySelectorAll(".mat-row");
            if (rows.length > 0) {
                const last = rows[rows.length - 1] as HTMLElement;
                last.scrollIntoView({ behavior: "smooth", block: "end" });
                this.isNextPressed = false;
            }
        });

        this.observer.observe(table, { childList: true, subtree: true });
        this.updateOverflowFlags();

        this.cellContents.changes.subscribe(() => this.updateOverflowFlags());
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private updateOverflowFlags(): void {
        this.overflowFlags = this.cellContents.map((el) =>
            this.isTextOverflowing(el.nativeElement),
        );
        this.cdr.detectChanges();
    }

    isTextOverflowing(element: HTMLElement): boolean {
        return element.scrollWidth > element.clientWidth;
    }

    isResizing = false;
    currentColumn: string | null = null;

    onResizeMouseDown(event: MouseEvent, columnDef: string) {
        this.isResizing = true;
        this.currentColumn = columnDef;

        const startX = event.pageX;
        const headerCell = (event.target as HTMLElement).parentElement!;
        const startWidth = headerCell.offsetWidth;

        const headerSpan = document.createElement("span");
        headerSpan.innerText = headerCell.innerText;
        headerSpan.style.visibility = "hidden";
        headerSpan.style.position = "absolute";
        headerSpan.style.whiteSpace = "nowrap";
        document.body.appendChild(headerSpan);
        const headerTextWidth = headerSpan.scrollWidth + 20;
        document.body.removeChild(headerSpan);

        const cells = Array.from(
            document.querySelectorAll(`.mat-column-${columnDef}`),
        ) as HTMLElement[];
        const maxContentWidth = Math.max(
            ...cells.map((cell) => {
                const span = document.createElement("span");
                span.innerText = cell.innerText;
                span.style.visibility = "hidden";
                span.style.position = "absolute";
                span.style.whiteSpace = "nowrap";
                cell.appendChild(span);
                const width = span.scrollWidth + 20;
                cell.removeChild(span);
                return width;
            }),
            headerTextWidth,
        );

        const mouseMove = (moveEvent: MouseEvent) => {
            if (!this.isResizing || !this.currentColumn) return;

            const diffX = moveEvent.pageX - startX;
            let newWidth = startWidth + diffX;

            newWidth = Math.max(
                headerTextWidth,
                Math.min(newWidth, maxContentWidth),
            );

            for (const cell of cells) {
                cell.style.width = `${newWidth}px`;
                cell.style.maxWidth = `${newWidth}px`;
                cell.style.minWidth = `${newWidth}px`;
            }
        };

        const stopResize = () => {
            this.isResizing = false;
            this.currentColumn = null;
            window.removeEventListener("mousemove", mouseMove);
            window.removeEventListener("mouseup", stopResize);
        };

        window.addEventListener("mousemove", mouseMove);
        window.addEventListener("mouseup", stopResize);
    }

    getTextWidth(text: string): number {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        if (context) {
            context.font = "14px Roboto"; // match table font
            return context.measureText(text).width;
        }
        return 100;
    }

    refreshTable() {
        this.dataSource.data = [];
        this.allCaseData = [];
        this.allCases = [];
        this.isInitComplete = true;
        this.isLoading = true;
        this.hasMoreData = true;
        this.prev = 0;
        this.next = 1;
        this.page = 0;
        this.count = 1;
        this.perPage = 10;
        this.selectedStatus = "all";
        localStorage.setItem("selectedCaseStatus", "all");
        this.getAllCases(1);
    }
}
